import * as React from 'react';
import AwaitingCustomers from '../../../../components/Query/WatchDogs/AvaitingCustomers'

export interface IWatchDogTabProps {
  productId: string;
}

export class WatchDogTab extends React.Component<IWatchDogTabProps> {

  public render() {

    return (
      <AwaitingCustomers productId={this.props.productId}>
        {(data) => {
          const {productWatchDogs: { loading, error, getAwaitingCustomers: awaitingCustomers}} = data;

          if (loading) {
            return null;
          }
          if (Array.isArray(awaitingCustomers)) {
            return awaitingCustomers.map((ac, i) => {
              if (ac.customer && ac.customer.email) {
                let customerString = ac.customer.invoiceFirstName || '';
                if (ac.customer.invoiceLastName) {
                  customerString = `${customerString} ${ac.customer.invoiceLastName}`;
                }
                if (customerString && ac.customer.invoiceCountry) {
                  customerString = `${customerString}, ${ac.customer.invoiceCountry}`;
                }
                customerString = ac.customer.invoiceCountry ? `${customerString}, ${ac.customer.email}` : ac.customer.email
                return <div key={`${ac.customer.email}${i}`}>{customerString}</div>
              } else if (ac.email) {
                return <div key={`${ac.email}${i}`}>{ac.email}</div>
              }
              return null;
            });
          }
          return  null;
        }}
      </AwaitingCustomers>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Products/ProductDetail/WatchDogTab/WatchDogTab.tsx